import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

interface UseMaintenanceEstablishmentChoiceManualEntryProposalsClientRejectProps {
  proposalId: string
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceEstablishmentChoiceManualEntryProposalsClientReject = ({
  proposalId,
  options,
}: UseMaintenanceEstablishmentChoiceManualEntryProposalsClientRejectProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceManualEntryProposalsClientReject'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/establishment_choice/manual_entry_proposals/${proposalId}/client_reject`)
    },
    ...options,
  })
}
